"use client";

import {NeoButton} from "@/components/forms";
import {NeoHeader} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import React, {useEffect, useMemo, useState} from "react";
import {AiOutlineLoading} from "react-icons/ai";
type ExpenseAddCommonFormProps = {
  onSubmit: (value: string) => void;
};

export const ExpenseAddCommonForm: React.FC<ExpenseAddCommonFormProps> = ({
  onSubmit
}) => {
  const maxDate = useMemo(() => new Date(), []);
  const {filterContext} = useNeoContext();
  const [loading, setLoading] = useState(false);
  const [loginUserId, setLoginUserId] = useState("");
  const [selected, setSelected] = useState<string>("");
  useEffect(() => {
    setSelected("1");
  }, []);

  const onsubmitclick = () => {
    onSubmit(selected);
  };
  return (
    <>
      <div className="flex w-full flex-col p-1">
        <div className="mb-2 flex-row font-bold">
          <NeoHeader message="Add Expense" />
        </div>
        <div className="">
          <label className="flex cursor-pointer items-center gap-3 px-2 py-3">
            <img src="/images/fuel_yellow.svg" alt="Fuel" className="h-4 w-4" />
            <span className="flex-1 text-[15px] text-gray-900">
              Fuel Expense
            </span>
            <input
              type="radio"
              name="expenseType"
              value="1"
              checked={selected === "1"}
              onChange={() => setSelected("1")}
              className="h-5 w-5 accent-emerald-600"
            />
          </label>
        </div>
        <div className="">
          <label className="flex cursor-pointer items-center gap-3 px-2 py-3">
            <img
              src="/images/service_yellow.svg"
              alt="Fuel"
              className="h-4 w-4"
            />
            <span className="flex-1 text-[15px] text-gray-900">
              Maintenance
            </span>
            <input
              type="radio"
              name="expenseType"
              value="2"
              checked={selected === "2"}
              onChange={() => setSelected("2")}
              className="h-5 w-5 accent-emerald-600"
            />
          </label>
        </div>
        <div className="">
          <label className="flex cursor-pointer items-center gap-3 px-2 py-3">
            <img
              src="/images/miscellaneous_yellow.svg"
              alt="Fuel"
              className="h-4 w-4"
            />
            <span className="flex-1 text-[15px] text-gray-900">
              Miscellaneous
            </span>
            <input
              type="radio"
              name="expenseType"
              value="3"
              checked={selected === "3"}
              onChange={() => setSelected("3")}
              className="h-5 w-5 accent-emerald-600"
            />
          </label>
        </div>
        <div className="flex items-center justify-center gap-2 p-4">
          <NeoButton
            onClick={onsubmitclick}
            type="submit"
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
            color="black"
          >
            Save
          </NeoButton>
        </div>
      </div>
    </>
  );
};
